<template>
  <div class="py-3 md:py-5">
    <div class="">
      <h3 class="py-1 md:py-2">Create brand consistency & get organizational oversight</h3>
      <p class="py-2">
        Our concierge will help set up a uniform process across all agents. Customize permissions
        and structure to meet the needs of your team. Contact us to find out how you can get the
        most return for your team.
      </p>
    </div>
  </div>

  <div class="flex flex-col">
    <div class="flex flex-col md:flex-row py-1">
      <div class="flex flex-col w-full md:w-2/3 md:mr-5">
        <label for="name" class="block">
          Team name
          <span class="text-brand-red">*</span>
        </label>
        <SingleLineInput
          id="name"
          type="text"
          placeholder="Enter your team name"
          :value="name"
          @input="name = $event.target.value"
        ></SingleLineInput>
      </div>

      <div class="flex flex-col w-full md:w-1/3">
        <label for="numAgents" class="block">
          # of agents
          <span class="text-brand-red">*</span>
        </label>
        <SingleLineInput
          id="numAgents"
          type="number"
          placeholder="Enter the # of agents"
          :value="`${numAgents}`"
          @input="numAgents = parseInt($event.target.value)"
        ></SingleLineInput>
      </div>
    </div>

    <div class="flex flex-col py-1">
      <label for="customMessage" class="block"> Attach a message </label>
      <MultiLineInput
        id="message"
        placeholder="Type to enter your message"
        :value="message"
        @input="message = $event.target.value"
      ></MultiLineInput>
    </div>

    <div class="flex flex-row justify-center py-3">
      <div class="w-full md:w-1/3">
        <PrimaryButton
          @click="sendMessage"
          :disabled="isCompanyLoading"
          :is-loading="isCompanyLoading"
          >Schedule a call</PrimaryButton
        >
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex"

import { COMPANY_CONTACT_SALES } from "@/store/types"

export default {
  computed: {
    ...mapGetters(["isCompanyLoading"])
  },
  data() {
    return {
      mode: null,
      name: "",
      numAgents: 0,
      message: ""
    }
  },
  methods: {
    async sendMessage() {
      const { name, numAgents, message } = this
      if (!name || !numAgents) {
        return
      }

      await this.$store.dispatch(COMPANY_CONTACT_SALES, {
        name,
        numAgents,
        message
      })

      this.$router.push({ name: "dashboard_forms" })
    }
  }
}
</script>
